<template>
  <side-panel-inner
    :headerTitle="editMode ? 'Edit Category' : 'Create a Category'"
    class="p-category-create"
  >
    <template v-if="editMode" slot="actions">
      <base-button
        :danger="true"
        button-style="danger"
        @click="deleteCategory"
        iconBefore="delete"
      >Delete</base-button>
      <base-button success :primary="true" @click="onSubmit">Save</base-button>
    </template>

    <template v-else slot="actions">
      <base-button :primary="true" @click="onSubmit">Create</base-button>
    </template>

    <!-- Category Name -->
    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>
    <form @submit.prevent="onSubmit">
      <form-field
        v-model="currentCategory.name"
        label="Category Name"
        required
        full-width
        v-validate="{required:true}"
        data-vv-name='CategoryName'
      />

      <form-field
        v-model="computedSlug"
        label="Category Slug"
        required
        full-width
        v-validate="{required:true}"
        data-vv-name='CategorySlug'
      />

      <form-field label="Parent Category">
        <form-type-ahead-select
          v-model="selectedCategory"
          id="parent_page"
          name="parent_page"
          :options="optionsForMenu"
          async-action="FormCategories/quickList"
          display-field="name"
          @input="onParentPageInput"
        />
      </form-field>

      <form-field
        v-model="currentCategory.description"
        label="Description"
        full-width
        type="textarea"
      />
    </form>

    <loading v-if="loading"></loading>
  </side-panel-inner>
</template>

<script>
import FormTypeAheadSelect from "@/components/FormTypeAheadSelect.vue";
import { mapState, mapGetters } from "vuex";
export default {
  name: "AdminFormCategoriesCreateEditPage",
  components: {
    FormTypeAheadSelect
  },
  mixins: [],
  props: {},
  data() {
    return {
      loading: true,
      searchQuery: "",
      showValidationMessage: false,
      editMode: false,
      selectedCategory: {}
    };
  },
  computed: {
    ...mapState("FormCategories", ["currentCategory"]),
    ...mapGetters("FormCategories", ["optionsForMenu"]),
    computedSlug() {
      return this.slugify(this.currentCategory.name);
    }
  },
  watch: {},
  beforeCreate() {},
  async created() {
    this.$store.commit("FormCategories/RESET_CURRENT_CATEGORY");
    // yea, we have to list them so that we can add a parent
    // nope, we should just be able to use the typeahead
    await this.$store.dispatch("FormCategories/list", { flat: true });
    this.loading = false;

    // do we have an id?  If so, we are editing
    if (this.$route.params.id) {
      this.loadCategory(this.$route.params.id);
    }
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  methods: {
    deleteCategory() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        confirm: () => {
          vm.$store
            .dispatch("FormCategories/delete", vm.$route.params.id)
            .then(() => {
              vm.$store.dispatch("CLOSE_PANEL");
            });
        }
      });
    },
    slugify(text) {
      if (!text) {
        return;
      }
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-"); // Replace multiple - with single -
    },
    loadCategory(id) {
      let category;

      this.$store
        .dispatch("FormCategories/read", id)
        .then(resp => {
          this.loading = false;
          this.editMode = true;
          if (this.currentCategory.parent_id) {
            this.selectedCategory = this.optionsForMenu.filter(
              item => item.id === this.currentCategory.parent_id
            )[0];
          }
        })
        .catch(err => {
          this.loading = false;
          this.editMode = false;
        });
    },

    onSubmit() {
      // TODO: Validate then save
      const vm = this;
      this.$validator.validate().then(result => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          vm.validationFailed = false;
          this.updateCategory();
        }
      });
    },
    async updateCategory() {
      // make sure slug is up to date
      this.currentCategory.slug = this.computedSlug;
      if (this.editMode) {
        await this.$store.dispatch("FormCategories/edit");
        this.$store.dispatch("CLOSE_PANEL");
        return;
      }
      await this.$store.dispatch("FormCategories/add");
      this.$store.dispatch("CLOSE_PANEL");
      return;
    },
    onParentPageInput(val) {
      this.currentCategory.parent_id = val.id;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>